import { Route, Switch } from "react-router-dom";
import MovimentacoesBancariasListagemPage from "./Listagem";

function MovimentacoesBancariasPages() {
  return (
    <Switch>
      <Route
        exact
        path="/financeiro/movimentacoes-bancarias"
        component={MovimentacoesBancariasListagemPage}
      />
    </Switch>
  );
}

export default MovimentacoesBancariasPages;
